import { forwardRef } from "react";

import styles from "./messageMarkdown.module.css";
import Markdown from "markdown-to-jsx";
import { Code } from "./code";

export const MarkdownMessage = forwardRef<HTMLDivElement, { content: string }>(
  ({ content }) => {
    return (
      <Markdown
        className={styles["genai-chat-ai-message-markdown"]}
        options={{
          overrides: {
            code: {
              component: Code,
            },
          },
        }}
      >
        {content}
      </Markdown>
    );
  },
);
